<template>
  <div class="d-flex flex-column align-center auth-forgot-password-root">
    <div class="d-flex flex-column align-center auth-forgot-password-container">
      <img :src="logo" alt="Anty Logo" />
      <p
        class="auth-forgot-password-form-title text-primary--text mt-8 mb-0 d-flex align-center justify-center"
        v-html="$t('auth.forgotPassword.headerTitle', forgotEmoji)"
      />
      <p class="auth-forgot-password-form-text ma-0 mt-2 text-caption--text">
        {{ $t('auth.forgotPassword.formText') }}
      </p>
    </div>
    <form
      class="auth-forgot-password-form d-flex flex-column justify-center align-center"
      @submit.prevent="handleFormSubmit"
    >
      <div class="auth-forgot-password-form-container mt-8">
        <!--USERNAME-->
        <auth-input
          :value="forgotPassword.username"
          :placeholder-and-label="{
            label: 'auth.forgotPassword.emailLabel',
            placeholder: 'auth.forgotPassword.emailPlaceholder',
            name: 'username'
          }"
          :error-state="{
            errorMessage: error,
            errorStatus: Boolean(error)
          }"
          :handle-change-value="changeInputValue"
        />
        <!--CAPTCHA START-->
        <div
          v-if="showCaptcha"
          class="captcha"
        >
          <captcha-wrapper
            captcha-id="forgot-password-captcha"
            :captcha-type="captchaType"
            @handle-captcha-response="handleCaptchaResponse"
          />
        </div>
        <!--CAPTCHA END-->
        <auth-button type="submit" :loading="loading">
          {{ $t('auth.forgotPassword.resetButton') }}
        </auth-button>
        <p
          class="align-self-center link-primary-text-default--text auth-forgot-password-login-link"
          @click="$router.push('/auth/login')"
        >
          {{ $t('auth.forgotPassword.loginLink') }}
        </p>
      </div>
    </form>
  </div>
</template>
<script>
import AuthInput from '@/components/auth/components/AuthInput.vue'
import AuthButton from '@/components/auth/components/AuthButton.vue'
import sadIcon from '@/assets/auth/so_sad.png'
import logo from '@/assets/antyLogo.svg'
import CaptchaWrapper from '@/components/CaptchaWrapper.vue'
import { MT_CAPTCHA_NAME } from '@/constants/auth/captcha'
import captcha from '@/mixins/captcha'
import { validateEmail } from '@/helpers/auth'

export default {
  name: 'AuthForgotPassword',

  components: { CaptchaWrapper, AuthButton, AuthInput },

  mixins: [ captcha ],

  data() {
    return {
      logo,
      forgotPassword: {
        username: '',
        count: parseInt(localStorage.getItem('requestResetPasswordCodeCount'), 10) || 0,
        captcha: null,
      },
      loading: false,
      showCaptcha: false,
      captchaType: MT_CAPTCHA_NAME,
      error: ''
    }
  },

  computed: {
    forgotEmoji() {
      return [
        `<img src="${sadIcon}" alt="Waving Hand"  width="20px" height="20px" style="margin-left: 4px; margin-right: 4px"/>`
      ]
    }
  },

  mounted() {
    localStorage.setItem('requestResetPasswordCodeCount', 0)
  },

  methods: {
    handleCaptchaResponse (verifiedToken) {
      this.forgotPassword.captcha = verifiedToken
    },

    changeInputValue(value, type) {
      this.forgotPassword[type] = value
    },

    async handleFormSubmit() {
      this.error = ''
      this.loading = true

      this.forgotPassword.username = this.forgotPassword.username.trim()

      if (this.forgotPassword.username.trim() === '') {
        this.error = 'auth.login.requiredField'
        this.loading = false
        return
      }

      if (!validateEmail(this.forgotPassword.username)) {
        this.error = 'auth.registration.emailError'
        this.loading = false
        return
      }

      try {
        localStorage.setItem('requestResetPasswordCodeCount', this.forgotPassword.count)

        await this.$store.dispatch('auth/forgotPassword', this.forgotPassword)
        await this.$router.push({
            name: 'ResetPassword',
            query: {
              username: this.forgotPassword.username,
              count: this.forgotPassword.count
            }
        })
        this.forgotPassword.count++
      } catch (e) {
        if (this.showCaptcha) {
          this.resetCaptcha(this.captchaType, 'forgot-password-captcha', this.handleResetHcaptcha)
        }

        if (e.response.status === 429) {
          this.error = 'auth.resetPassword.toManyAttempts'
        }

        if (e.response.status === 400) {
          this.showCaptcha = true
          this.captchaType = e.response.data
        }

        console.error(e.message)
      } finally {
        this.loading = false
      }
    },

    handleResetHcaptcha () {
      this.$refs?.captchaWrapper.$refs.captcha?.reset()
    },
  }
}
</script>

<style scoped lang="scss">
.auth-forgot-password-root {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.auth-forgot-password-form-text{
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.auth-forgot-password-container {
  width: 400px;
  text-align: center;
}

.auth-forgot-password-form {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  width: 400px;
  font-weight: 400;
  line-height: 20px;
}

.auth-forgot-password-send-code-again {
  border-bottom: 1px solid var(--v-link-primary-border-default-base);
}

.auth-forgot-password-agreement {
  gap: 10px;
}

.auth-forgot-password-form-title {
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.auth-forgot-password-form-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.auth-forgot-password-login-link {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration: none;
  border-bottom: 1px solid var(--v-link-primary-border-default-base);
  cursor: pointer;
}

.auth-forgot-password-login-link {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration: none;
  border-bottom: 1px solid var(--v-link-primary-border-default-base);
  cursor: pointer;
}
</style>
